import React from 'react'
import PropTypes from 'prop-types'
import { Column, Row, Section, Strong } from './PartnershipCertificateDialog.styles'

/**
 * The sellerInformacion component.
 */
const SellerInformation = props => {
  const { businessName, datesAccepted, dni, error, isSTU, loading, mechanismName, purchaseOrderID } = props

  return (
    <>
      {!error && !loading && (
        <Section opaque margin="0 0 20px" padding="20px">
          <Row container>
            <Column item maxWidth="210px" padding="0 30px 0 0" xs={3}>
              <Strong>{`Razón Social ${isSTU ? 'apoderado' : ''}`}</Strong>
            </Column>
            <Column item xs={9}>
              {businessName}
            </Column>
          </Row>
          <Row container>
            <Column item maxWidth="210px" padding="0 30px 0 0" xs={3}>
              <Strong>{`RUT ${isSTU ? 'apoderado' : ''}`}</Strong>
            </Column>
            <Column item xs={9}>
              {dni}
            </Column>
          </Row>
          {!!purchaseOrderID && (
            <Row container>
              <Column item maxWidth="210px" padding="0 30px 0 0" xs={3}>
                <Strong>Nº orden de compra</Strong>
              </Column>
              <Column item xs={9}>
                {purchaseOrderID}
              </Column>
            </Row>
          )}
          {!!datesAccepted && (
            <Row container>
              <Column item maxWidth="210px" padding="0 30px 0 0" xs={3}>
                <Strong>Fecha de aceptación orden de compra</Strong>
              </Column>
              <Column item xs={9}>
                {datesAccepted}
              </Column>
            </Row>
          )}
          {!!mechanismName && (
            <Row container>
              <Column item maxWidth="210px" padding="0 30px 0 0" xs={3}>
                <Strong>Mecanismo de compra</Strong>
              </Column>
              <Column item xs={9}>
                {mechanismName}
              </Column>
            </Row>
          )}
        </Section>
      )}
    </>
  )
}

SellerInformation.defaultProps = {
  businessName: '',
  datesAccepted: undefined,
  dni: '',
  error: false,
  isSTU: 0,
  loading: false,
  mechanismName: '',
  purchaseOrderID: undefined
}

SellerInformation.propTypes = {
  businessName: PropTypes.string.isRequired,
  datesAccepted: PropTypes.string,
  dni: PropTypes.string.isRequired,
  error: PropTypes.bool,
  isSTU: PropTypes.number,
  loading: PropTypes.bool,
  mechanismName: PropTypes.string.isRequired,
  purchaseOrderID: PropTypes.number
}

export default SellerInformation
